import React from 'react';
import { ReactComponent as BlueCaret } from '../../../images/assessments/report/img/cover/blue-caret.svg';

const CoverPage = ({ assessment }) => {
	const preparedBy = () => {
		if (!assessment.participant.company_logo) {
			return null;
		}

		return (
			<div className='prepared-by'>
				<div className='ttg-container'>
					<p>Prepared by:</p>
					<img src={assessment.participant.company_logo} alt={''} />
				</div>
			</div>
		);
	};

	return (
		<div className='Cover'>
			<div className='top py-8 mx-auto'>
				<div className={'w-2/3 mx-auto'}>
					<p className={'top-title'}>Assessment Report</p>
				</div>
			</div>

			<div className='mt-6'>
				<img  src='../../../images/assessments/report/img/cover/CoverLogoV2.png' alt={''} className={'w-3/4 mx-auto px-5'} />
			</div>

			<div className='gears my-12'>
				<img src='../../../images/assessments/report/img/cover/CoverBreakLine.png' alt={''} />
			</div>

			<p className='tagline'>
				{assessment.participant.fname} {assessment.participant.lname}
				{assessment.participant.lname[assessment.participant.lname.length - 1] === 's' ? '' : '’s'} Working
				Genius Revealed
			</p>

			<div className='footer'>
				<div className='gear'>
					<div className='dot'>
						<p>
							DISCOVER THE <br />
							GIFTS YOU BRING <br /> TO WORK
							<br />
						</p>
						<BlueCaret className="caret" />
					</div>
				</div>
			</div>

			{preparedBy()}

			<div className='powered-by'>
				<div className='ttg-container'>
					<p>Powered by:</p>
					<img src='../../../images/assessments/report/img/cover/TTGWhiteReportLogo.png' alt={''} />
				</div>
			</div>
		</div>
	);
};

export default CoverPage;
